"use client"

import {
  getParcelStatusKey,
} from "@/lib/helpers/parcel-statuses"
import { cn } from "@/lib/utils"
import { useTranslate } from "@tolgee/react"
import { OrderProductListItem } from "@/components/cells/OrderProductListItem/OrderProductListItem"

const STATUS_COLORS: Record<string, string> = {
  received: "#155DFC",
  preparing: "#F59E0B",
  shipped: "#8B5CF6",
  delivered: "#00A63E",
  canceled: "#DC2626",
}

export const ParcelAccordionItems = ({
  order,
  currency_code,
  isLast,
}: {
  order: any
  index: number
  currency_code: string
  isLast?: boolean
}) => {
  const { t } = useTranslate()

  const statusKey = getParcelStatusKey(order.status, order.fulfillment_status)
  const statusText = t(`parcel_status.${statusKey}`)
  const color = STATUS_COLORS[statusKey] || STATUS_COLORS.received

  return (
    <div className={cn("bb-order-parcel bg-white", !isLast && "border-b border-[#e5e7eb]")}>
      <div className="py-[10px] px-[20px] flex items-center justify-between">
        <div className="flex items-center gap-[32px] flex-wrap">
          <p className="bb-order-card-meta text-[14px] font-normal text-[#6a7282] leading-[20px]">
            ORDER
            <span className="bb-order-card-title font-semibold text-[#1e2939] ml-1">
              #{order.display_id}
            </span>
          </p>
          <div
            className="px-[8px] py-[2px] rounded-[4px] text-[12px] font-medium leading-[16px]"
            style={{
              backgroundColor: `${color}1A`,
              color,
            }}
          >
            {statusText}
          </div>
          <p className="text-[14px] font-normal text-[#6a7282] leading-[20px]">
            {t("parcel_accordion_items.seller")}:
            <span className="font-semibold text-[#1e2939] ml-1">
              {order.seller?.name}
            </span>
          </p>
        </div>
      </div>

      <div>
        {(order.items || []).map((item: any) => (
          <OrderProductListItem
            key={item.id + item.variant_id}
            item={item}
            currency_code={currency_code}
          />
        ))}
      </div>
    </div>
  )
}
